module.exports = __webpack_public_path__ + "img/avatar.394560d4.png";